export default "__VITE_PUBLIC_ASSET__c731bf85__"